import service from './service';

export default {
  // 发送聊天通知
  sendChatMessage(data) {
    return service.post('/api/v1/message/send-chat-message', data);
  }
};



// WEBPACK FOOTER //
// ./src/api/message.js